import React from "react";
import { getLocalFromUtc } from "../../../../utils/dates";
import { formatDate } from "../../../../utils/dates";
import { formatCurrency } from "../../../../utils/moneyFormat";
import { SaleSummaryProps } from "../interfaces";

export const SaleSummary: React.FC<SaleSummaryProps> = ({
  concession,
  date,
  event,
  seller,
  subtotal,
  tip,
  reassignedTip,
  appServiceFee,
  total,
}) => {
  return (
    <div className="space-y-3">
      <h2 className="text-lg font-medium text-gray-800">Resumen</h2>
      <div className="overflow-hidden rounded-xl border border-gray-200 bg-white">
        <div className="grid grid-cols-1 gap-0 p-0 lg:grid-cols-12">
          <div className="space-y-6 p-4 lg:col-span-8">
            <div className="grid grid-cols-2 gap-6">
              <div>
                <div className="mb-1 text-sm text-gray-500">Evento</div>
                <div className="text-sm font-medium capitalize">
                  {event ? event.toLowerCase() : "-"}
                </div>
              </div>
              <div>
                <div className="mb-1 text-sm text-gray-500">Concesión</div>
                <div className="text-sm font-medium capitalize">
                  {concession ? concession.toLowerCase() : "-"}
                </div>
              </div>
            </div>
            <div className="grid grid-cols-2 gap-6">
              <div>
                <div className="mb-1 text-sm text-gray-500">Vendedor</div>
                <div className="text-sm font-medium capitalize">
                  {seller ? seller.toLowerCase() : "-"}
                </div>
              </div>
              <div>
                <div className="mb-1 text-sm text-gray-500">Fecha y hora</div>
                <div className="text-sm font-medium">
                  {date ? `${formatDate(getLocalFromUtc(date))} hrs.` : "-"}
                </div>
              </div>
            </div>
          </div>
          <div className="flex flex-col justify-between p-4 lg:col-span-4 lg:border-l lg:border-gray-200">
            <div className="space-y-2">
              <div className="flex items-center justify-between">
                <div className="text-sm text-gray-500">Subtotal:</div>
                <div className="text-sm font-medium">
                  {formatCurrency(subtotal)}
                </div>
              </div>
              <div className="flex items-center justify-between">
                <div className="text-sm text-gray-500">Propina:</div>
                <div className="text-sm font-medium">{formatCurrency(tip)}</div>
              </div>
              {reassignedTip && (
                <div className="text-xs text-amber-700">
                  {`Propina de ${formatCurrency(reassignedTip.amount)} movida a la concesión “${reassignedTip.concession}”.`}
                </div>
              )}
              {appServiceFee > 0 && (
                <div className="flex items-center justify-between">
                  <div className="text-sm text-gray-500">Comisión:</div>
                  <div className="text-sm font-medium">
                    {formatCurrency(appServiceFee)}
                  </div>
                </div>
              )}
            </div>
            <div className="mt-4 border-t border-gray-200 pt-4">
              <div className="flex items-center justify-between">
                <div className="text-base font-medium">Total:</div>
                <div className="text-base font-bold text-primary">
                  {formatCurrency(total + (appServiceFee ?? 0))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
